import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'distributors',
            name: 'distributor',
            class: 'Modules\\Distributor\\Entities\\Distributor',

            dataTable: {
                headerTopComponents: [
                    {
                        component: 'export-component',
                        bind: {
                            href: route('pages.admin.site.distributors.export'),
				            text: "Exportar Sucursales"
                        },
                        html: null,
                        on: {}
                    }
                ],
                headerBottomComponents: [
                    // {
                    //     component: the-component,
                    //     bind: {},
                    //     html: null,
                    //     on: {}
                    // }
                ]
            }
        }
    }
}